// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_15r1g3R0EjSVrRFw_I_uzn"};